import without from 'lodash/without';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import values from 'lodash/values';
import {
  BEGIN_SEARCH_REQUEST,
  EMPTY_ARRAY,
  EMPTY_OBJECT,
  END_SEARCH_REQUEST,
  SEARCH_SOURCE,
  SET_SEARCH_SOURCE,
  SET_SEARCH_TEXT,
  TOGGLE_FILTER_FAVORITES,
  TOGGLE_FILTER_LICENSED,
  TOGGLE_SEARCH_TAG,
  UPDATE_SEARCH_REQUEST,
} from '../constants';

const DEFAULT_STATE = {
  filterToFavorites: false,
  filterToLicensed: false,
  source: SEARCH_SOURCE.ALL_SCENES,
  tags: EMPTY_ARRAY,
  text: undefined,
  queries: {
    // someHashValue: {
    //   hit: [clipId],
    //   cursor: '',
    //   found: 0,
    //   fetching: Promise || undefined,
    // },
  },
};

export default function(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case BEGIN_SEARCH_REQUEST:
      return {
        ...state,
        queries: {
          ...state.queries,
          [action.payload.key]: {
            hit: EMPTY_ARRAY,
            cursor: undefined,
            found: undefined,
            ...(state.queries[action.payload.key] || EMPTY_OBJECT),
            fetching: action.payload.fetching,
          },
        },
      };
    case END_SEARCH_REQUEST:
      return {
        ...state,
        queries: {
          ...state.queries,
          [action.payload.key]: {
            ...state.queries[action.payload.key],
            fetching: undefined,
          },
        },
      };
    case SET_SEARCH_SOURCE:
      return {
        ...state,
        source: values(SEARCH_SOURCE).includes(action.payload)
          ? action.payload
          : state.source,
      };
    case SET_SEARCH_TEXT:
      return {
        ...state,
        text: action.payload,
      };
    case TOGGLE_FILTER_FAVORITES:
      return {
        ...state,
        filterToFavorites:
          action.payload !== undefined
            ? action.payload
            : !state.filterToFavorites,
      };
    case TOGGLE_FILTER_LICENSED:
      return {
        ...state,
        filterToLicensed:
          action.payload !== undefined
            ? action.payload
            : !state.filterToLicensed,
      };
    case TOGGLE_SEARCH_TAG: {
      const isInState = state.tags.includes(action.payload.tagId);
      let newState = action.payload.state;
      if (newState === undefined) {
        newState = !isInState;
      }
      const newTags = without(state.tags, action.payload.tagId);
      if (newState) {
        newTags.push(action.payload.tagId);
      }
      return {
        ...state,
        tags: sortBy(uniq(newTags)),
      };
    }
    case UPDATE_SEARCH_REQUEST:
      return {
        ...state,
        queries: {
          ...state.queries,
          [action.payload.key]: {
            ...state.queries[action.payload.key],
            hit: state.queries[action.payload.key].hit.concat(
              action.payload.hit,
            ),
            cursor: action.payload.cursor,
            found: action.payload.found,
          },
        },
      };
    default:
      return state;
  }
}

function radioToggle(primary, prevState, nextState, others) {
  const primaryState = nextState !== undefined ? nextState : !prevState;
  const result = { [primary]: primaryState };
  if (others.map !== undefined) {
    others.map(other => (result[other] = !primaryState));
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/search.js